import { createReducer } from '@reduxjs/toolkit';
import { setStagesListAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(setStagesListAction, (state, action) => {
    state.list = action.payload;
  })
);
